<template>
  <div class="wrapper">
    <div class="container">
      <div class="md-layout">
        <div
          class="
            md-layout-item md-size-80 md-small-size-100
            mx-auto
            text-center
          "
        >
          <md-card class="md-card md-card-signup">
            <md-card-content>
              <div
                :style="{
                  'background-image': 'url(atg_bkg.png)',
                  'background-size': 'cover',
                  opacity: 0.1,
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                }"
              ></div>
              <div style="position: relative;">
              <img src="ateshgah.png" alt="" style="width: 200px;" />
              <br />
              <md-icon>phone</md-icon
              ><b><span style="font-size: 14pt">Çağrı mərkəzi</span></b
              ><br />

              <a
                :href="'tel:+994124971737'"
                style="font-size: 14pt; color: red; font-weight: bold;"
              >
                (+994 12) 497-17-37/67</a
              >
              <h3 class="card-title text-center">
                Könüllü tibbi sığorta <br />#214791
              </h3>
              </div>
              <div class="md-layout">
                <div class="md-layout-item md-size-100 text-left">
                  <h3>Sığorta olunan</h3>
                </div>
                <div class="md-layout-item md-size-100 text-left">
                  <h4 style="font-weight: bold; margin-top: -10px">Baxşəliyev Xəqani Fidusi</h4>
                </div>

                <div class="md-layout-item md-size-100 text-left">
                  <h3>Proqram</h3>
                </div>
                <div class="md-layout-item md-size-100 text-left">
                  <h4 style="font-weight: bold; margin-top: -10px">Standart Plus</h4>
                </div>

                <div class="md-layout-item md-size-100 text-left">
                  <h3>Müddəti</h3>
                </div>
                <div class="md-layout-item md-size-100 text-left">
                  <h4 style="font-weight: bold; margin-top: -10px">01.05.2020 - 30.04.2021</h4>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <div>
            <div class="ico-div">
              <a
                href="https://www.facebook.com/ateshgahinsurancegroup/"
                target="_blank"
              >
                <img src="social/f.png" />
              </a>
              <a
                href="https://www.instagram.com/ateshgah_insurance_group/"
                target="_blank"
              >
                <img src="social/i.png" />
              </a>
              <a
                href="https://www.linkedin.com/company/ateshgah-insurance-group/"
                target="_blank"
              >
                <img src="social/in.png" />
              </a>
              <a href="tel:+994555535503" style="text-decoration: none">
                <img src="social/t.png" />
              </a>
              <a href="https://wa.me/994555535503" target="_blank">
                <img src="social/w.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- <ul class="socials">
        <li>
          <a href="https://facebook.com/ateshgahinsurancegroup/">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
              <use xlink:href="#svg-fb"></use>
            </svg>
          </a>
        </li>
        <li>
          <a href="https://instagram.com/ateshgah_insurance_group/">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
              <use xlink:href="#svg-instagram"></use>
            </svg>
          </a>
        </li>
        <li>
          <a href="https://youtube.com/channel/UCTKEkToE5lEufQQ63iNfYZw">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
              <use xlink:href="#svg-youtube"></use>
            </svg>
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/company/ateshgah-insurance-group">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
              <use xlink:href="#svg-linkedin"></use>
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
              <use xlink:href="#svg-twitter"></use>
            </svg>
          </a>
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      visit: "",
      notsent: true,
      feedback1: "",
      feedback2: "",
      feedback3: "",
      feedback4: "",
      notes: "",
      //   labels: ["Pis", "Məyus", "Adi", "Yaxşı", "Əla"],
      labels: ["", "", "", "", ""],
    };
  },
  methods: {},
};
</script>

<style >
.page-header {
  height: auto !important;
}
a {
  text-decoration: none;
  padding-left: 5px;
}
.ico-div {
  margin-bottom: 5px;
  text-align: center;
}
.ico-div img {
  width: 30px;
}
</style>